import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import site from "@/config/site";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-[#27331C]">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
      <div className="flex flex-col lg:flex-row justify-between gap-10">
        <div>
          <img src="/logo-sanvalio.png" alt="Sanvalio" className="h-12 sm:h-14 w-auto" />
          <p className="mt-3 font-mono2 text-[10px] tracking-[0.3em] text-[#8A8C7E]">
            STRATEGY / DESIGN / GROWTH
          </p>
        </div>
        <div className="flex flex-wrap gap-x-10 gap-y-4 items-start">
          {[
            { label: "Free Brand Audit", to: "/audit", testid: "footer-audit-link" },
            { label: "Book Growth Call", to: "/book?plan=growth", testid: "footer-book-link" },
          ].map((l) => (
            <Link key={l.label} to={l.to} data-testid={l.testid}
              className="group flex items-center gap-1 text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">
              {l.label}
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          ))}
          <a href={site.social.sanvalio} target="_blank" rel="noopener noreferrer" data-testid="footer-sanvalio-link"
            className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">sanvalio.com ↗</a>
          <a href={site.social.design4you} target="_blank" rel="noopener noreferrer" data-testid="footer-design4you-link"
            className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">design4you.co.in ↗</a>
          {site.social.instagram && (
            <a href={site.social.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"
              className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">Instagram ↗</a>
          )}
          {site.social.facebook && (
            <a href={site.social.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link"
              className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">Facebook ↗</a>
          )}
          {site.social.instagramD4Y && (
            <a href={site.social.instagramD4Y} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-d4y-link"
              className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">IG · Design4You ↗</a>
          )}
          {site.social.facebookD4Y && (
            <a href={site.social.facebookD4Y} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-d4y-link"
              className="text-sm text-[#B9BBAC] hover:text-[var(--accent)] transition-colors duration-300">FB · Design4You ↗</a>
          )}
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-[#27331C] flex flex-col sm:flex-row justify-between gap-3">
        <span className="font-mono2 text-[10px] tracking-[0.2em] text-[#5A5D4E]">
          © {new Date().getFullYear()} SANVALIO · IDEAS TO IMPACT
        </span>
        <span className="font-mono2 text-[10px] tracking-[0.2em] text-[#5A5D4E]">
          BUILT FOR FOUNDERS WHO ARE DONE GUESSING
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
